<template>
  <div>
    <a-card class='mb16'>

    <contract-duty-amount v-if="basicInfoProps" :id="basicInfoProps.contract_id" ></contract-duty-amount>
    </a-card>
      <footer-btn v-if="basicInfoProps.curr_step_num<stepInfo.stepNum && canEdit" :btnText="{
        okText: '保存'
      }" @on-save="onSave" :noCancelBtn="true"></footer-btn>
  
 </div>
</template>

<script>
import {
  // addContractAmount,
  // contractAmountStatistic,
  // contractAmountList,
  // saveDocAmounts,
  // editContractAmount,
  // deleteContractAmount,
  // getNextStepName,
  // contractAmountOption
} from "../../services/DocService.js";
import moment from "moment";
import SvgIcDate from "../../assets/svg/ic-date-o.svg";
import { ContractDutyAmount } from "@/components/detailTableArea";

export default {
  props: {
basicInfoProps: Object,
stepInfo:Object,  
canEdit: Boolean,
  },
  components: {

ContractDutyAmount 
  },
  methods: {
 onSave() {
     
   
          this.$emit("change-step", {
            curr_step_num: this.stepInfo.stepNum,
            next_step: this.stepInfo.nextStepNum
          });
        
    },
   
  },
  data() {
    

    return {
      
  }
}
}
</script>

<style lang="less">
.doc-money-change-record {
  margin-top: 16px;
}
</style>
